import customAxios from "../../customAxios";
import {DELETE_DRIVER} from "../../routes";

const deleteDriver = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_DRIVER + `/${userId}`)).data;
  } catch (error: any) {
    console.log({DELETE_DRIVER: error});
    return false;
  }
};

export default deleteDriver;
